'use es6';

import PropTypes from 'prop-types';
import { Button } from 'foundations-components/transitional/components/Button';
import { Badge } from 'foundations-components/transitional/components/Badge';
import FormattedMessage from 'I18n/components/FormattedMessage';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
function ShareToSlackButton({
  disabled,
  showNewBadge,
  showPanel
}) {
  return /*#__PURE__*/_jsxs(Button, {
    onClick: showPanel,
    disabled: disabled,
    children: [/*#__PURE__*/_jsx(FormattedMessage, {
      message: "slackUiLibrary.shareToSlackButton.text"
    }), showNewBadge && /*#__PURE__*/_jsx(Badge, {
      use: "new",
      children: /*#__PURE__*/_jsx(FormattedMessage, {
        message: "slackUiLibrary.shareToSlackButton.newBadge"
      })
    })]
  });
}
ShareToSlackButton.propTypes = {
  disabled: PropTypes.bool,
  showNewBadge: PropTypes.bool,
  showPanel: PropTypes.func.isRequired
};
export default ShareToSlackButton;